/**
 * コラム目次（TOC）の生成とトグル制御
 *
 * .m-article-content 内の h2/h3 をスキャンして目次を動的生成し、
 * h2 が1件以上あれば .m-column-toc を表示する。
 */
const columnToc = () => {
  const toc = document.querySelector('.m-column-toc');
  const tocList = document.querySelector('.m-column-toc__list');
  const content = document.querySelector('.m-article-content');

  if (!toc || !tocList || !content) return;

  const headings = content.querySelectorAll('h2, h3');
  if (!headings.length) return;

  let h2Index = 0;
  let currentItemContent = null;
  let currentSubList = null;

  headings.forEach((heading, idx) => {
    if (!heading.id) {
      heading.id = `toc-h-${idx}`;
    }

    if (heading.tagName === 'H2') {
      h2Index++;
      const num = String(h2Index).padStart(2, '0');

      const li = document.createElement('li');
      li.className = 'm-column-toc__item';

      const numSpan = document.createElement('span');
      numSpan.className = 'm-column-toc__item-num';
      numSpan.textContent = num;

      const itemContent = document.createElement('div');
      itemContent.className = 'm-column-toc__item-content';

      const titleLink = document.createElement('a');
      titleLink.href = `#${heading.id}`;
      titleLink.className = 'm-column-toc__item-title';
      titleLink.textContent = heading.textContent;

      itemContent.appendChild(titleLink);
      li.appendChild(numSpan);
      li.appendChild(itemContent);
      tocList.appendChild(li);

      currentItemContent = itemContent;
      currentSubList = null;
    } else if (heading.tagName === 'H3' && currentItemContent) {
      if (!currentSubList) {
        currentSubList = document.createElement('ul');
        currentSubList.className = 'm-column-toc__sub-list';
        currentItemContent.appendChild(currentSubList);
      }

      const subItem = document.createElement('li');
      subItem.className = 'm-column-toc__sub-item';

      const subIcon = document.createElement('span');
      subIcon.className = 'm-column-toc__sub-icon';
      subIcon.setAttribute('aria-hidden', 'true');
      subIcon.innerHTML =
        '<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">' +
        '<path d="M11 17.825L14.7085 14L11 10.175L12.1417 9L17 14L12.1417 19L11 17.825Z" fill="#A6A6A6"/>' +
        '</svg>';

      const subLink = document.createElement('a');
      subLink.href = `#${heading.id}`;
      subLink.className = 'm-column-toc__sub-text';
      subLink.textContent = heading.textContent;

      subItem.appendChild(subIcon);
      subItem.appendChild(subLink);
      currentSubList.appendChild(subItem);
    }
  });

  if (h2Index === 0) return;

  // 目次を表示
  toc.removeAttribute('hidden');

  // トグル制御
  const btn = toc.querySelector('.js-column-toc-btn');
  const toggleIcon = toc.querySelector('.m-column-toc__toggle');
  const body = toc.querySelector('.m-column-toc__body');

  if (!btn || !toggleIcon || !body) return;

  const setExpanded = (expanded) => {
    const state = String(expanded);
    btn.setAttribute('aria-expanded', state);
    // CSS が .m-column-toc__toggle[aria-expanded="true"] で回転を制御
    toggleIcon.setAttribute('aria-expanded', state);
    if (expanded) {
      body.removeAttribute('hidden');
    } else {
      body.setAttribute('hidden', '');
    }
  };

  // 初期状態：展開済み
  setExpanded(true);

  btn.addEventListener('click', () => {
    const isExpanded = btn.getAttribute('aria-expanded') === 'true';
    setExpanded(!isExpanded);
  });
};

export { columnToc };
